import {
    selectSelectorGenerator,
    writeSelectorGenerator,
  } from '../qa-hooks/typedSelectorHelpers';
  
  const QaHooks = {};
  
  const hooks = { 
    captchaCheckbox: 'captchaCheckbox',
  };
  
  const Selectors = { ...selectSelectorGenerator(hooks), ...QaHooks };
  const WriteSelectors = writeSelectorGenerator(hooks);
  
  export { Selectors, WriteSelectors };